import React from "react";

import pluralize from "pluralize";

import OnboardingProgressIndicator from "features/Setup/OnboardingProgressIndicator";

import { useRoutes } from "utils/routes";
import { useNow } from "utils/hooks";

import TrackedLink from "ui/TrackedLink";
import { useCurrentOrganization } from "providers/WithCurrentOrganization";

const PageOnboardingNav: React.FunctionComponent = () => {
  const organization = useCurrentOrganization(true);
  const { serverSetup, organizationSetup, organizationSubscription } =
    useRoutes();

  const now = useNow();

  if (!organization || organization.planInfo.activeSubscription) {
    return null;
  }

  const daysRemaining =
    organization.planInfo.trialEndsAt == null
      ? 0
      : (organization.planInfo.trialEndsAt * 1000 - now) /
        (24 * 60 * 60 * 1000);

  const stepsRemaining = organization.onboardingProgress.integratedExplain
    ? 0
    : organization.onboardingProgress.integratedLogInsights
    ? 1
    : organization.onboardingProgress.integratedCollector
    ? 2
    : 3;
  const linkTarget =
    daysRemaining <= 0 || stepsRemaining === 0
      ? organizationSubscription(organization.slug)
      : organization.onboardingProgress.lastIntegratedServer
      ? serverSetup(
          organization.onboardingProgress.lastIntegratedServer.humanId,
        )
      : organizationSetup(organization.slug);

  const timeRemainingBlurb =
    stepsRemaining === 0
      ? null
      : daysRemaining > 1
      ? pluralize("day", Math.floor(daysRemaining), true) +
        " remaining in your trial"
      : daysRemaining > 0
      ? "Less than 24h left in your trial"
      : "";

  return (
    <div className="ml-1">
      <TrackedLink
        href={linkTarget}
        eventCategory="Setup Link"
        eventLabel={stepsRemaining === 0 ? "Upgrade to paid plan" : "Setup"}
      >
        <OnboardingProgressIndicator
          stepsRemaining={stepsRemaining}
          trialExpired={daysRemaining <= 0}
        />
      </TrackedLink>
      {timeRemainingBlurb && (
        <p className="pl-2 text-xs text-[var(--color-blue-150)]">
          {timeRemainingBlurb}
        </p>
      )}
    </div>
  );
};

export default PageOnboardingNav;
